import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { defaultColumns, columnTitles } from 'src/app/store/settings.era';
import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { JoiEvent } from 'src/app/store/events.era';
import { Wrapper } from 'src/app/components/wrapper.component';
import { ColumnOrderType } from 'globals/store/settings.data';
import { DefaultColumnSelectData } from '../../helpers/table-helpers';
import { Dictionary } from '@ngrx/entity';
import { jsonCopyObject } from 'globals/helpers/helpers';
import { UserSettings } from 'globals/store/user.data';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';


export interface EditColumnsData {
  type: ColumnOrderType
  title: string
}
@Component({
    selector: 'edit-columns-dialog',
    template: `
<div class="edit-columns-dialog joi-dialog">
  <div mat-dialog-title>{{ title }}</div>
  <div mat-dialog-content>
    <div class="label">Choose which columns you see and drag to change the order.</div>
    <div class="multi-select">
      <div style="flex:1;"></div>
      <div class="action" (click)="selectAll()">Select All</div>
      <div class="action" (click)="unselectAll()">Unselect All</div>
    </div>
    <div class="columns" cdkDropList (cdkDropListDropped)="drop($event)">
        <ng-container *ngFor="let col of displayedColumns">
          <div class="column" [ngClass]="{ dim: vars.termsOff }" *ngIf="{ termsOff: false } as vars"  cdkDrag>
              <mat-checkbox  color="primary" [(ngModel)]="col.selected" [disabled]="col.value=='user'"></mat-checkbox>
              <div class="drag_label">
                  <icon cdkDragHandle matIcon="drag_indicator"></icon>
                  <div class="name-holder">
                    <div class="name">{{columnTitles[col.value]}}</div>
                    <div class="info" *ngIf="vars.termsOff">(when enabled in performer information)</div>
                  </div>
                  <span></span>
              </div>
          </div>
        </ng-container>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="resetColumns()">RESET COLUMNS</button>
    <div style="flex:1;"></div>
    <button mat-button (click)="dialogRef.close()">CANCEL</button>
    <button mat-button color="primary" (click)="saveColumns()" tabindex="1">Save</button>
  </div>
</div>
  `,
    styleUrls: [`./workforce.main.scss`],
    styles: [`
    .column.dim { opacity: 0.7; }
    .name-holder { display: flex; align-items: center; white-space: no-wrap; }
    .name-holder .info { font-size: 11px; margin: 2px 0 0 3px; }
    .multi-select { display: flex; }
    .action { cursor: pointer; margin-left: 10px; color: #5A97A6; }
  `],
    standalone: true,
    imports: [CdkDragHandle, CdkDrag, CommonModule, MatDialogModule, MatButtonModule, MatCheckboxModule, FormsModule, CdkDropList],
})


export class EditColumnsDialogComponent extends Wrapper<EditColumnsDialogComponent> {
  event: JoiEvent
  columnTitles: Dictionary<string>
  displayedColumns: DefaultColumnSelectData[]
  defaults: DefaultColumnSelectData[]
  columnType: ColumnOrderType
  title = 'Edit Columns'

  constructor(public dialogRef: MatDialogRef<EditColumnsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ColumnOrderType | EditColumnsData) {
    super()
    if (typeof data === 'string') {
      this.columnType = data
    } else {
      this.columnType = data.type
      this.title = data.title
    }

    this.displayedColumns = jsonCopyObject(defaultColumns[this.columnType])
    this.defaults = jsonCopyObject(defaultColumns[this.columnType])
    this.columnTitles = columnTitles[this.columnType]
    
    const columnsKey: keyof UserSettings = `${this.columnType}_columns` as keyof UserSettings;
    console.log({ data: this.columnType, columnsKey, displayedColumns: this.displayedColumns, columnTitles: this.columnTitles, defaultColumns })

    this.subCallback(this.store.select('settings', 'user', columnsKey), columns => {
      if (columns) this.displayedColumns = columns
    })
    this.subProp(this.store.select('events', 'event'), 'event')
  }

  resetColumns() {
    this.displayedColumns = jsonCopyObject(this.defaults)
  }

  selectAll() {
    this.displayedColumns.forEach(c => c.selected = true)
  }

  unselectAll() {
    this.displayedColumns.forEach(c => c.selected = false)
  }

  saveColumns() {
    this.settingsService.saveUserSetting(`${this.columnType}_columns` as any, [...this.displayedColumns])
    // this.store.dispatch(new UpdateUserSetting('workforce_columns', [...this.displayedColumns]))
    this.dialogRef.close();
  }
  drop(event: CdkDragDrop<string[]>) {
      moveItemInArray(this.displayedColumns, event.previousIndex, event.currentIndex);
  }

}


